export default __webpack_public_path__ + "41aaf0792e8aeda27ec19e03ec90d9ea.png";